import gql from "graphql-tag";

// fragment
export const PRODUCT_CATEGORY_FRAGMENT = gql`
    fragment productCategory on ProductCategoryNode {
        id
        name
        printPriority
        updatedAt
        updatedBy
    }
`;

// all query
export const PRODUCT_CATEGORIES_QUERY = gql`
    query {
        tenantProductCategories {
            edges {
                node {
                    ...productCategory
                }
            }
        }
    }
    ${PRODUCT_CATEGORY_FRAGMENT}
`;

// single query
export const SINGLE_PRODUCT_CATEGORY_QUERY = gql`
    query productCategory($id: ID!) {
        productCategory(id: $id) {
            ...productCategory
        }
    }
    ${PRODUCT_CATEGORY_FRAGMENT}
`;

// create
export const CREATE_PRODUCT_CATEGORY_MUTATION = gql`
    mutation createProductCategory($input: CreateProductCategoryInput!) {
        createProductCategory(input: $input) {
            productCategory {
                ...productCategory
            }
        }
    }
    ${PRODUCT_CATEGORY_FRAGMENT}
`;

// update
export const UPDATE_PRODUCT_CATEGORY_MUTATION = gql`
    mutation updateProductCategory($input: UpdateProductCategoryInput!) {
        updateProductCategory(input: $input) {
            productCategory {
                ...productCategory
            }
        }
    }
    ${PRODUCT_CATEGORY_FRAGMENT}
`;

// delete
export const DELETE_PRODUCT_CATEGORY_MUTATION = gql`
    mutation deleteProductCategory($input: DeleteProductCategoryInput!) {
        deleteProductCategory(input: $input) {
            productCategory {
                ...productCategory
            }
        }
    }
    ${PRODUCT_CATEGORY_FRAGMENT}
`;
